// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ii5XqxN8oIeUuiL6JWOn{grid-column:1/-1;background-color:#fff}.i1etnmniXWoSDUVKqzXx{display:inline-flex;justify-content:flex-start;align-items:center;color:#1874fd}.i1etnmniXWoSDUVKqzXx.VMbni24r4FSS_9bFj8_L{color:#91a5bc}.PfBBM1bpk64iSqaB9cTZ{display:inline-block;font-weight:400;font-size:2rem;margin-right:14px}.MSQ9Yh_L1zdV_ngc_L7G{text-align:start;font-weight:700;font-size:.875rem}.FTDETSfqWUoMqQXD_ba6{width:100%;background-color:\"#635ee7\"}.UmT5fx44axuJ6itpysJ4{width:100%}@media(max-width: 767px){.UmT5fx44axuJ6itpysJ4{display:none}}@media(min-width: 768px){.aiTJDIEv7OPWPEHqE6hI{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"steps": "Ii5XqxN8oIeUuiL6JWOn",
	"stepsLabel": "i1etnmniXWoSDUVKqzXx",
	"disabled": "VMbni24r4FSS_9bFj8_L",
	"stepsLabelNumeric": "PfBBM1bpk64iSqaB9cTZ",
	"stepsLabelText": "MSQ9Yh_L1zdV_ngc_L7G",
	"stepsIndicator": "FTDETSfqWUoMqQXD_ba6",
	"stepsMain": "UmT5fx44axuJ6itpysJ4",
	"stepsProgress": "aiTJDIEv7OPWPEHqE6hI"
};
export default ___CSS_LOADER_EXPORT___;
